import { callGuestAPI } from "../axios/guestAxios";

async function allCountries() {
  const options = {
    method: "GET",
    url: "/reservation/v1/get-all-countries",
  };
  const res = await callGuestAPI(options);
  return res;
}

async function allTitles() {
  const options = {
    method: "GET",
    url: "/reservation/v1/get-all-titles",
  };
  const res = await callGuestAPI(options);
  return res;
}

async function maintenanceStatus() {
  const options = {
    method: "GET",
    url: "/reservation/v1/maintenance-status",
  };
  const res = await callGuestAPI(options);
  return res;
}

const DropdownServices = {
  allCountries,
  allTitles,
  maintenanceStatus
};

export default DropdownServices;
